/**
 * «Мій профіль» (PRF-01; user-cabinet.md, розд. 10.5): `/profile` — лінивий чанк features/profile.
 * Розділ сторінки — якір `#<id>` розділу (features/profile/sections.ts), а не параметр адреси.
 */
import { createRoute } from '@tanstack/react-router';
import { PROFILE_PATH } from '../../shell/nav-model.ts';
import { rootRoute } from './root.tsx';

export const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: PROFILE_PATH,
}).lazy(() => import('../../features/profile/ProfilePage.tsx').then((m) => m.ProfileRoute));
